import React from 'react';
import TickCircle from '../Icons/TickCircle';
import CloseIcon from '../Icons/CloseIcon';
import ErrorIconCircle from '../Icons/ErrorIconCircle';
import ExclamationCircle from '../Icons/ExclamationCircle';

const alertStyle = {
  backgroundColor: '#5C5D6B',
};

const buttonStyle = {
  backgroundColor: '#68697B',
};

export interface AlertTemplateProps {
  message: string;
  options: any;
  style: any;
  close: any;
}
const AlertTemplate = ({ message, options, style, close }: any) => {
  return (
    <div
      className="rounded-md shadow-lg flex items-center justify-between h-14 overflow-hidden pl-4"
      style={{ ...alertStyle, ...style }}
    >
      {options.type === 'info' && (
        <ExclamationCircle size={22} className="block w-6 h-6 text-gray-50" />
      )}
      {options.type === 'success' && (
        <TickCircle className="block w-6 h-6 text-green-600" size={22} />
      )}
      {options.type === 'error' && (
        <ErrorIconCircle className="block w-6 h-6 text-red-400" size={22} />
      )}
      <div className="p-4 text-white text-sm font-medium">
        <span style={{ flex: 2 }}>{message}</span>
      </div>
      <button
        onClick={close}
        style={buttonStyle}
        className="text-white h-full w-14 flex items-center justify-center cursor-pointer hover:text-red-200"
      >
        <CloseIcon className="block w-5 h-5" size={20} />
      </button>
    </div>
  );
};

export default AlertTemplate;
